var _desc, _defs, _rect, _circle, _circle2, _g, _g2, _text, _text2, _rect2, _text3, _text4, _text5, _path, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharlieIntelligence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 520",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Charlie Intelligence Platform preview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Dark market intelligence dashboard with data cards, charts, and the Charlie brand mark.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#101722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#162235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c121d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "panel",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#223149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121c2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blue",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42d5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b72d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "green",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4ef3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68bf08"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 18,
    floodColor: "#020714",
    floodOpacity: 0.42
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 520,
    rx: 0,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 90,
    r: 190,
    fill: "#2563eb",
    opacity: 0.18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 828,
    cy: 72,
    r: 150,
    fill: "#23c4ff",
    opacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 64,
    width: 820,
    height: 392,
    rx: 26,
    fill: "url(#panel)",
    stroke: "#5d78a6",
    strokeOpacity: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 98,
    width: 190,
    height: 324,
    rx: 18,
    fill: "#0e1726",
    stroke: "#5d78a6",
    strokeOpacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 98,
    width: 536,
    height: 90,
    rx: 18,
    fill: "#111d2e",
    stroke: "#5d78a6",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 216,
    width: 260,
    height: 206,
    rx: 18,
    fill: "#111d2e",
    stroke: "#5d78a6",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604,
    y: 216,
    width: 252,
    height: 206,
    rx: 18,
    fill: "#111d2e",
    stroke: "#5d78a6",
    strokeOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130 124) scale(0.62)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "24,88 134,24 182,52 72,116",
    fill: "url(#blue)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24,88 72,116 24,144",
    fill: "#0c9fe3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24,144 72,116 110,138 62,166",
    fill: "#126dca"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128,70 182,100 182,148 128,118",
    fill: "url(#green)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126,132 156,149 128,165 98,148",
    fill: "#6f7378"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98,178 156,145 212,178 154,212",
    fill: "#303134"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154,212 212,178 212,146 154,180",
    fill: "#8a8d91"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 306,
    fill: "#f2f7ff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 800
  }, "Charlie")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 344,
    fill: "#9fb3d1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 600
  }, "Market intelligence")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 372,
    width: 118,
    height: 28,
    rx: 14,
    fill: "#15345c",
    stroke: "#3b82f6",
    strokeOpacity: 0.45
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 151,
    y: 392,
    fill: "#bfe1ff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700
  }, "AWS CDK")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 348,
    y: 136,
    fill: "#f5f8ff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 800
  }, "Live signal board")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 348,
    y: 166,
    fill: "#97a8c5",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 600
  }, "Stocks, FX, weather, traffic, news, and AI analyst workflows")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M638 160 L674 132 L712 150 L748 118 L792 138 L830 104",
    fill: "none",
    stroke: "#7dd3fc",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 262,
    fill: "#f2f7ff",
    fontSize: 18,
    fontWeight: 800
  }, "Cross-industry analytics"), /*#__PURE__*/React.createElement("path", {
    d: "M350 370 C386 318 418 354 454 304 C496 246 536 314 558 274",
    fill: "none",
    stroke: "#c4ef3a",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 386 C386 360 420 378 454 346 C500 302 528 334 558 320",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 394,
    x2: 560,
    y2: 394,
    stroke: "#5d78a6",
    strokeOpacity: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 284,
    x2: 350,
    y2: 394,
    stroke: "#5d78a6",
    strokeOpacity: 0.28
  }), /*#__PURE__*/React.createElement("text", {
    x: 632,
    y: 262,
    fill: "#f2f7ff",
    fontSize: 18,
    fontWeight: 800
  }, "Platform services"), /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 292,
    width: 184,
    height: 22,
    rx: 11,
    fill: "#213553"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 292,
    width: 144,
    height: 22,
    rx: 11,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 330,
    width: 184,
    height: 22,
    rx: 11,
    fill: "#213553"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 330,
    width: 116,
    height: 22,
    rx: 11,
    fill: "#8dcc25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 368,
    width: 184,
    height: 22,
    rx: 11,
    fill: "#213553"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 368,
    width: 154,
    height: 22,
    rx: 11,
    fill: "#42d5ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharlieIntelligence);
export default __webpack_public_path__ + "static/media/charlie-intelligence.96d557355bc5a8b395e87252cc00c6af.svg";
export { ForwardRef as ReactComponent };